import React from "react";
import { connect } from "react-redux";
import moment from 'moment';
import ClaimsHeader from "./Components/ClaimsHeader/ClaimsHeader";
import Grid from "@material-ui/core/Grid";
import Principal from "../../../containers/Policyv2/Components/Principal/Principal";
import ClaimInitiationWrapper from "./Components/ClaimInitiationWrapper/ClaimInitiationWrapper";
import { getCustomer } from "../../../containers/Customer/actions.es6";
import *  as actions from "./Redux/actions"
import SelectPolicy from "./Components/SelectPolicy/SelectPolicy";
import SelectMember from "./Components/SelectMember/SelectMember";
import ClaimLoggingDetails from "./Components/ClaimLoggingDetails/ClaimLoggingDetails";
import ClaimDetails from "./Components/ClaimDetails/ClaimDetails";
import { getPartnerGuid, getUserFullname, getUserGuid } from "../../../lib/access.es6";
import { OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS } from "../../../lib/constants";
import AdditionalDetails from "./Components/AdditionalDetails/AdditionalDetails";
import find from 'lodash/find';
//import { getAllPoliciesRequest } from "../CustomerStatus/Redux/actions";
import { getAllPoliciesRequest } from "../../MalipoWws/CustomerStatus/Redux/actions";
import ClaimSummary from "./Components/ClaimSummary/ClaimSummary";

// Maps the free-text "Cause Of Admission" dropdown value (HospitalClaimDetails.js) to the lowercase
// enum the underwriter's HCP claim flow requires (accident/illness/surgery/pregnancy/pre_existing).
const CAUSE_OF_ADMISSION_TO_ENGINE_CAUSE = {
  'Illness': 'illness',
  'Accident': 'accident',
  'Surgery': 'surgery',
  'Pregnancy-related': 'pregnancy',
};

// Pristine wizard state, shared by the constructor and handleResetClaimData(). "Generate Another Claim"
// (ClaimInitiationWrapper's handleReset) used to only reset the step index, leaving every field here -
// benefits (which HCP-vs-Death branching in handleInitiateMthunziClaim reads), admission_date,
// discharge_date, cause_of_hospitilization, etc. - from the just-submitted claim still in place for the
// next one, so e.g. a Death claim submitted right after an HCP claim could still carry stale
// Hospital Cash data and trip the underwriter's HCP-specific validation.
function getInitialClaimState() {
  return {
    claimInitiationPayload: {
      "event_date": null,
      "policy_guid": null,
      "policy_number": null,
      "quotation_guid": null,
      "customer_guid": null,
      "dependant_guid": null,
      "partner": null,
      "benefits": [],
      "initiator_fullname": null,
      "initiator_msisdn": null,
      "web_agent_guid": null,
      "web_agent_name": null,
      "additional_details": null,
      "claimant_msisdn": null,
      "claimant_email": null,
      "claimant_first_name": null,
      "claimant_last_name": null,
    },

    "claimant_phone_number": '',
    "claimant_full_name": '',
    "claimant_id_number": '',
    "claimant_relationship_to_patient": '',
    "admission_date": '',
    "discharge_date": '',
    "number_of_days_in_hospital": '',
    "date_of_death": '',
    "funeral_home_name": '',
    "death_certficate_number": '',
    "device_number": '',
    "date_of_damage": '',
    "date_of_disability": '',
    "date_of_theft": '',
   "beneficiary_national_id": '',
   "loan_amount": '',
   "loan_disbursement_date": '',
   "loan_duration": '',
   "loan_maturity_date": '',
   "loan_type": '',
   "monthly_installment_amount": '',
   "real_people_commission": '',
   "loan_interest_rate": '',
   "product_code": '',
   "monthly_interest_rate": '',
   "location_of_business": '',
   "type_of_business": '',
   "policy_start_date": '',
   "date_of_event": '',
   "details_of_event": '',
   "hospital_attended": '',
   "inpatient_number": '',
   "cause_of_hospitilization": '',
   "weakly_loan_amount": '',
   "nature_of_illnes_or_disability": '',
   "patient_number": '',
   "outstanding_loan_amount_at_date_of_event": '',
   "cause_of_death": '',
   "type_of_cancer": '',
   "claimant_bank_name": '',
    "claimant_bank_account_number": '',
    "claimant_mpesa_phone_number": '',
    "claimant_payment_option": '',
    "attending_physician": '',
    "type_of_disability": '',
    "burial_certificate_number": '',
    "claimant_bank_account_holder": '',
    "claimant_bank_branch_code": '',
   // "claimant_email": '',
    age: '',
    claimSummaryData: {}
  };
}

class ClaimInitiation extends React.Component {
  constructor(props) {
    super(props);

    this.state = getInitialClaimState();

  }

  setAdditionalState(name, value){
    this.setState({[name]: value})
  }

  // Restores every claim-specific field back to its pristine value - called when the agent chooses to
  // submit a new claim from the "What would you like to do next" screen, so a fresh claim never inherits
  // benefits, dates or other fields left over from whatever was just submitted.
  handleResetClaimData() {
    this.setState(getInitialClaimState());
    // Also clear the verified-event redux state (eventQuoteSuccess/eventQuoteError/eventQuote) -
    // otherwise a stale eventQuoteSuccess=true from the JUST-SUBMITTED claim leaves the Select
    // Policy step's Next button enabled with no policy or date chosen (shouldDisableNext in
    // ClaimInitiationWrapper.js only gates on eventQuoteSuccess), and the stale eventQuote object
    // (still holding the previous claim's policy/quotation) would silently carry through to the
    // rest of the wizard if the agent clicks Next without re-selecting a policy.
    this.resetEventQuote();
  }

  componentWillMount() {

     let customer_guid = this.props.params.customer_guid
    if (customer_guid) {
      this.refreshCustomerDetails(customer_guid)
    }
    if(customer_guid){
      this.props.dispatch(getAllPoliciesRequest({ guid: customer_guid }))
    }


    if (customer_guid) {
      this.props.dispatch(actions.getCustomerClaimsDcpRequest({
        guid: customer_guid
      })
      );
    }


  }


	refreshCustomerDetails(customer_guid) {
    this.props.dispatch(getCustomer(customer_guid))

	}
  
   getAge(){
    const member = this.state.claimInitiationPayload.member ? this.state.claimInitiationPayload.member.dependant : null

    if (member) {

      const dob = member.date_of_birth;
      const currentDate = moment();
      const birthDate = moment(dob);
      const currentAge = currentDate.diff(birthDate, 'years');
      return currentAge;
    }
    return ""
  };

  handleSelectPolicies(payload) {
    this.props.dispatch(actions.getEventQuoteRequest(payload));
  }

  // Clear the verified-event state so that changing the policy or event date
  // forces the user to re-verify before they can proceed.
  resetEventQuote() {
    this.props.dispatch(actions.resetgetEventQuoteSuccess());
    this.props.dispatch(actions.resetgetEventQuoteError());
  }

  // Lets SelectPolicy reject a claim client-side (e.g. event date past the policy's grace
  // period) without a round trip - dispatches straight to the same failure state a real backend
  // rejection would produce, so eventQuoteSuccess stays false and the wizard's Next button stays
  // disabled exactly as it does for a genuine backend-rejected event.
  rejectEventQuote(detail, reason) {
    this.props.dispatch(actions.getEventQuoteFailure({ detail, reason }));
  }

  handleClaimSummary() {
    let payload = this.state.claimInitiationPayload;
    payload['policy_guid'] = this.props.claimInitiationData.eventQuote.policy_guid;
    payload['policy_number'] = this.state.claimInitiationPayload.policy_number;
    payload['quotation_guid'] = this.props.claimInitiationData.eventQuote.guid;
    payload['customer_guid'] = this.props.claimInitiationData.eventQuote.customer_guid;
    payload['product_code'] = this.props.claimInitiationData.eventQuote.product_code;
    payload['partner'] = this.props.claimInitiationData.eventQuote.partner;
    payload['web_agent_guid'] = getUserGuid();
    payload['web_agent_name'] = getUserFullname();

    payload = {
      ...payload,
      policy_number2: this.state.claimInitiationPayload.policy_number,
      initiator_fullname: this.state.claimant_full_name,
      initiator_msisdn: this.state.claimant_phone_number,
      claimant_msisdn: this.state.claimant_phone_number,
      claimant_email: this.state.claimant_email,
      claimant_first_name: this.state.claimant_full_name.split(' ')[0],
      claimant_last_name: this.state.claimant_full_name.split(' ')[1] || '',
      additional_details: {
        ...payload.additional_details,
        admission_date: this.state.admission_date,
        discharge_date: this.state.discharge_date,
        number_of_days_in_hospital: this.state.number_of_days_in_hospital,
        date_of_death: this.state.event_date,
        funeral_home_name: this.state.funeral_home_name,
        death_certficate_number: this.state.death_certficate_number,
        device_number: this.state.device_number,
        date_of_damage: this.state.date_of_damage,
        date_of_disability: this.state.date_of_disability,
        date_of_theft: this.state.date_of_theft,
        installment_amount: this.state.installment_amount,
        claimant_full_name: this.state.claimant_full_name,
        claimant_id_number: this.state.claimant_id_number,
        claimant_relationship_to_patient: this.state.claimant_relationship_to_patient,
        claimant_bank_name: this.state.claimant_bank_name,
        claimant_bank_account_number: this.state.claimant_bank_account_number,
        claimant_mpesa_phone_number: this.state.claimant_mpesa_phone_number,
        claimant_bank_account_holder: this.state.claimant_bank_account_holder,
        claimant_bank_branch_code: this.state.claimant_bank_branch_code,
        claimant_payment_option: this.state.claimant_payment_option,
        age: this.getAge(),
        beneficiary_national_id: this.state.beneficiary_national_id,
        loan_amount: this.state.loan_amount,
        loan_disbursement_date: this.state.loan_disbursement_date,
        loan_duration: this.state.loan_duration,
        loan_maturity_date: this.state.loan_maturity_date,
        loan_type: this.state.loan_type,
        monthly_installment_amount: this.state.monthly_installment_amount,
        real_people_commission: this.state.real_people_commission,
        loan_interest_rate: this.state.loan_interest_rate,
        product_code: this.state.product_code,
        monthly_interest_rate: this.state.monthly_interest_rate,
        location_of_business: this.state.location_of_business,
        type_of_business: this.state.type_of_business,
        policy_start_date: this.state.policy_start_date,
        date_of_event: this.state.date_of_event,
        details_of_event: this.state.details_of_event,
        hospital_attended: this.state.hospital_attended,
        inpatient_number: this.state.inpatient_number,
        cause_of_hospitilization: this.state.cause_of_hospitilization,
        weakly_loan_amount: this.state.weakly_loan_amount,
        nature_of_illnes_or_disability: this.state.nature_of_illnes_or_disability,
        patient_number: this.state.patient_number,
        outstanding_loan_amount_at_date_of_event: this.state.outstanding_loan_amount_at_date_of_event,
        cause_of_death: this.state.cause_of_death,
        type_of_cancer: this.state.type_of_cancer,
        attending_physician: this.state.attending_physician,
        type_of_disability: this.state.type_of_disability,
        burial_certificate_number: this.state.burial_certificate_number,
      }
    }

    console.log('payload: ', payload);

    this.setState({claimSummaryData: payload})
  }

  // Mthunzi (Old Mutual Malawi) submits claims through the underwriter engine directly - the same
  // policy-dcp-underwriter flows the USSD channel uses via mailroom - rather than the generic
  // /api/claims/complex/initiate_claim endpoint every other partner still uses. The engine validates
  // policy status, event date window, waiting periods, and benefit coverage synchronously, returning a
  // clear, specific rejection reason instead of silently queuing an invalid claim. quotation_guid and
  // customer_guid are NOT needed here - the engine resolves those itself from policy_guid. product_code
  // ('mthunzi_death' | 'mthunzi_hcp') tells the engine's router which of Mthunzi's two claim flows to
  // run - both share one endpoint (/api/onboard_claim), same as every other partner.
  handleInitiateMthunziClaim() {
    const policy_guid = this.props.claimInitiationData.eventQuote.policy_guid;
    const dependant_guid = this.state.claimInitiationPayload.dependant_guid;
    const isHcpClaim = !!find(this.state.claimInitiationPayload.benefits, { type: 'Hospital Cash Benefit' });

    const shared = {
      initiator_fullname: this.state.claimant_full_name,
      initiator_msisdn: this.state.claimant_phone_number,
      web_agent_guid: getUserGuid(),
      web_agent_name: getUserFullname(),
    };

    if (isHcpClaim) {
      this.props.dispatch(actions.initiateClaimRequest({
        __engineFlow: 'mthunzi',
        product_code: 'mthunzi_hcp',
        policy_guid,
        dependant_guid,
        admission_date: this.state.admission_date,
        discharge_date: this.state.discharge_date,
        cause: CAUSE_OF_ADMISSION_TO_ENGINE_CAUSE[this.state.cause_of_hospitilization] || '',
        claimant_first_name: this.state.claimant_full_name.split(' ')[0],
        claimant_last_name: this.state.claimant_full_name.split(' ')[1] || '',
        claimant_msisdn: this.state.claimant_phone_number,
        claimant_email: this.state.claimant_email,
        additional_details: {
          hospital_name: this.state.hospital_attended,
          claimant_id_number: this.state.claimant_id_number,
          claimant_relationship_to_patient: this.state.claimant_relationship_to_patient,
        },
        ...shared,
      }));
      return;
    }

    this.props.dispatch(actions.initiateClaimRequest({
      __engineFlow: 'mthunzi',
      product_code: 'mthunzi_death',
      policy_guid,
      dependant_guid,
      event_date: this.state.claimInitiationPayload.event_date,
      benefits: this.state.claimInitiationPayload.benefits,
      claimant_first_name: this.state.claimant_full_name.split(' ')[0],
      claimant_last_name: this.state.claimant_full_name.split(' ')[1] || '',
      claimant_msisdn: this.state.claimant_phone_number,
      claimant_email: this.state.claimant_email,
      additional_details: {
        cause_of_death: this.state.cause_of_death,
        funeral_home_name: this.state.funeral_home_name,
        death_certficate_number: this.state.death_certficate_number,
        claimant_id_number: this.state.claimant_id_number,
        claimant_relationship_to_patient: this.state.claimant_relationship_to_patient,
      },
      ...shared,
    }));
  }

  handleInitiateClaim() {
    if (getPartnerGuid() === 'old_mutual_malawi') {
      this.handleInitiateMthunziClaim();
      return;
    }

    let payload = this.state.claimInitiationPayload;
    payload['policy_guid'] = this.props.claimInitiationData.eventQuote.policy_guid;
    payload['policy_number'] = this.state.claimInitiationPayload.policy_number;
    payload['quotation_guid'] = this.props.claimInitiationData.eventQuote.guid;
    payload['customer_guid'] = this.props.claimInitiationData.eventQuote.customer_guid;
    payload['product_code'] = this.props.claimInitiationData.eventQuote.product_code;
    payload['partner'] = this.props.claimInitiationData.eventQuote.partner;
    payload['web_agent_guid'] = getUserGuid();
    payload['web_agent_name'] = getUserFullname();

    payload = {
      ...payload,
      policy_number2: this.state.claimInitiationPayload.policy_number,
      initiator_fullname: this.state.claimant_full_name,
      initiator_msisdn: this.state.claimant_phone_number,
      claimant_email: this.state.claimant_email,
      claimant_first_name: this.state.claimant_full_name.split(' ')[0],
      claimant_last_name: this.state.claimant_full_name.split(' ')[1] || '',
      claimant_msisdn: this.state.claimant_phone_number,
      additional_details: {
        ...payload.additional_details,
        admission_date: this.state.admission_date,
        discharge_date: this.state.discharge_date,
        number_of_days_in_hospital: this.state.number_of_days_in_hospital,
        date_of_death: this.state.event_date,
        funeral_home_name: this.state.funeral_home_name,
        death_certficate_number: this.state.death_certficate_number,
        device_number: this.state.device_number,
        date_of_damage: this.state.date_of_damage,
        date_of_disability: this.state.date_of_disability,
        date_of_theft: this.state.date_of_theft,
        installment_amount: this.state.installment_amount,
        claimant_full_name: this.state.claimant_full_name,
        claimant_id_number: this.state.claimant_id_number,
        claimant_relationship_to_patient: this.state.claimant_relationship_to_patient,
        claimant_bank_name: this.state.claimant_bank_name,
        claimant_bank_account_number: this.state.claimant_bank_account_number,
        claimant_mpesa_phone_number: this.state.claimant_mpesa_phone_number,
        claimant_bank_account_holder: this.state.claimant_bank_account_holder,
        claimant_bank_branch_code: this.state.claimant_bank_branch_code,
        claimant_payment_option: this.state.claimant_payment_option,
        age: this.getAge(),
        beneficiary_national_id: this.state.beneficiary_national_id,
        loan_amount: this.state.loan_amount,
        loan_disbursement_date: this.state.loan_disbursement_date,
        loan_duration: this.state.loan_duration,
        loan_maturity_date: this.state.loan_maturity_date,
        loan_type: this.state.loan_type,
        monthly_installment_amount: this.state.monthly_installment_amount,
        real_people_commission: this.state.real_people_commission,
        loan_interest_rate: this.state.loan_interest_rate,
        product_code: this.state.product_code,
        monthly_interest_rate: this.state.monthly_interest_rate,
        location_of_business: this.state.location_of_business,
        type_of_business: this.state.type_of_business,
        policy_start_date: this.state.policy_start_date,
        date_of_event: this.state.event_date,
        details_of_event: this.state.details_of_event,
        hospital_attended: this.state.hospital_attended,
        inpatient_number: this.state.inpatient_number,
        cause_of_hospitilization: this.state.cause_of_hospitilization,
        weakly_loan_amount: this.state.weakly_loan_amount,
        nature_of_illnes_or_disability: this.state.nature_of_illnes_or_disability,
        patient_number: this.state.patient_number,
        outstanding_loan_amount_at_date_of_event: this.state.outstanding_loan_amount_at_date_of_event,
        cause_of_death: this.state.cause_of_death,
        type_of_cancer: this.state.type_of_cancer,
        attending_physician: this.state.attending_physician,
        type_of_disability: this.state.type_of_disability,
        burial_certificate_number: this.state.burial_certificate_number,
      }
    }
    this.props.dispatch(actions.initiateClaimRequest(payload));
  }

  render() {


    if (!this.props.customerData.currentCustomer) {
      return "Loading...";
  }

const partnerGuid = getPartnerGuid()

// (4) ['Accidental Death', 'Natural Death', 'Partial Permanent Disability', 'Total Permanent Disability']



  const hasCashbackBenefit= !!find(this.state.claimInitiationPayload.benefits, {type: "Cashback"})
  const hasFuneralNaturalDeath = partnerGuid === 'omk'  ?  !!find(this.state.claimInitiationPayload.benefits, {type: "Last_Expense"}) : !!find(this.state.claimInitiationPayload.benefits, {type: "Funeral Natural Death"})
  const hasFuneralAccidentalDeath = !!find(this.state.claimInitiationPayload.benefits, {type: "Funeral Accidental Death"})
  // Mthunzi exposes a single "Hospital Cash Benefit" on the quote; the
  // illness/accident split is captured later via Cause of Admission.
  const hasHospiCashIllnessBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Hospital Cash Benefit"})
  const hasRewardsBenefits = !!find(this.state.claimInitiationPayload.benefits, {type: "Rewards"})
  const hasHospiCashAccidentBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Hospital Cash Benefit"})
  const hasAccidentalDeathBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Accidental Death"}) || !!find(this.state.claimInitiationPayload.benefits, {type: "Accidental_Death"})
  const hasNaturalDeathBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Natural Death"}) || !!find(this.state.claimInitiationPayload.benefits, {type: "Natural_Death"})
  const hasPartialPermanentDisabilityBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Partial Permanent Disability"}) || !!find(this.state.claimInitiationPayload.benefits, {type: "Partial_Permanent_Disability"})
  const hasTotalPermanentDisabilityBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Total Permanent Disability"}) || !!find(this.state.claimInitiationPayload.benefits, {type: "Total_Permanent_Disability"})
  const isMalawiFuneralBenefits = !!find(this.state.claimInitiationPayload.benefits, (benefit) => {
    return OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS.includes(benefit.type)
  })

    return (
      <>
        <ClaimsHeader title="Initiate Claim " />
        <Grid container spacing={2}>
          <Grid xs={12} md={3} sm={3}>
            <Principal
              customerData={this.props.customerData.currentCustomer}
              loader={false}
            />
          </Grid>
          <ClaimInitiationWrapper
            policies={this.props.customerStatusV2Data.policies}
            handleSelectPolicies={this.handleSelectPolicies.bind(this)}
            selectedMember={this.props.claimInitiationData.selectedPolicy}
            eventQuote={this.props.claimInitiationData.eventQuote}
            eventQuoteSuccess={this.props.claimInitiationData.eventQuoteSuccess}
            customerClaimsDcp={
              this.props.claimInitiationData.customer_claims_dcp
            }
            handleInitiateClaim={this.handleInitiateClaim.bind(this)}
            createdClaim={this.props.claimInitiationData.initiateClaim}
            handleClaimSummary={this.handleClaimSummary.bind(this)}
            handleResetClaimData={this.handleResetClaimData.bind(this)}
            admissionDate={this.state.admission_date}
            dischargeDate={this.state.discharge_date}
            dateOfDeath={this.state.claimInitiationPayload.event_date}
            hospital_attended={this.state.hospital_attended}
            cause_of_hospitilization={this.state.cause_of_hospitilization}
            inpatient_number={this.state.inpatient_number}
            number_of_days_in_hospital={this.state.number_of_days_in_hospital}
            funeral_home_name={this.state.funeral_home_name}
            cause_of_death={this.state.cause_of_death}
            death_certficate_number={this.state.death_certficate_number}
            hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
            hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
            hasFuneralNaturalDeath={hasFuneralNaturalDeath}
            hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
            isMalawiFuneralBenefits={isMalawiFuneralBenefits}
            claimPayload={this.state}
            components={{
              SelectPolicy: (
                <SelectPolicy
                  policies={this.props.customerStatusV2Data.policies}
                  customerData={this.props.customerData.currentCustomer}
                  handleSelectPolicies={this.handleSelectPolicies.bind(this)}
                  resetEventQuote={this.resetEventQuote.bind(this)}
                  rejectEventQuote={this.rejectEventQuote.bind(this)}
                  eventQuoteSuccess={
                    this.props.claimInitiationData.eventQuoteSuccess
                  }
                  eventQuoteLoader={
                    this.props.claimInitiationData.eventQuoteLoader
                  }
                  eventQuoteError={
                    this.props.claimInitiationData.eventQuoteError
                  }
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                />
              ),
              SelectMember: (
                <SelectMember
                  eventQuote={this.props.claimInitiationData.eventQuote}
                  customerClaimsDcp={
                    this.props.claimInitiationData.customer_claims_dcp
                  }
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                />
              ),

              AdditionalDetails: (
                <AdditionalDetails
                  hasCashbackBenefit={hasCashbackBenefit}
                  hasFuneralNaturalDeath={hasFuneralNaturalDeath}
                  hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
                  hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
                  hasRewardsBenefits={hasRewardsBenefits}
                  hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
                  hasAccidentalDeathBenefit={hasAccidentalDeathBenefit}
                  hasNaturalDeathBenefit={hasNaturalDeathBenefit}
                  hasPartialPermanentDisabilityBenefit={hasPartialPermanentDisabilityBenefit}
                  hasTotalPermanentDisabilityBenefit={hasTotalPermanentDisabilityBenefit}
                  isMalawiFuneralBenefits={isMalawiFuneralBenefits}
                  handleInitiateClaim={this.handleInitiateClaim.bind(this)}
                  eventQuote={this.props.claimInitiationData.eventQuote}
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  claimState={this.state}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                  member={
                    this.state.claimInitiationPayload.member
                      ? this.state.claimInitiationPayload.member.dependant
                      : null
                  }
                  eventDate={this.state.claimInitiationPayload.event_date}
                  setAdditionalState={this.setAdditionalState.bind(this)}
                  eventData={this.props.claimInitiationData.eventQuote}
                  customerClaimsDcp={this.props.claimInitiationData.customer_claims_dcp}
                />
              ),

              ClaimLoggingDetails: (
                <ClaimLoggingDetails
                  handleInitiateClaim={this.handleInitiateClaim.bind(this)}
                  eventQuote={this.props.claimInitiationData.eventQuote}
                  hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
                  hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  claimState={this.state}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                  setAdditionalState={this.setAdditionalState.bind(this)}
                />
              ),

              ClaimSummary: (
                <ClaimSummary
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  claimSummaryData={this.state.claimSummaryData}
                  hasCashbackBenefit={hasCashbackBenefit}
                  hasFuneralNaturalDeath={hasFuneralNaturalDeath}
                  hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
                  hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
                  hasRewardsBenefits={hasRewardsBenefits}
                  hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
                  hasAccidentalDeathBenefit={hasAccidentalDeathBenefit}
                  hasNaturalDeathBenefit={hasNaturalDeathBenefit}
                  hasPartialPermanentDisabilityBenefit={hasPartialPermanentDisabilityBenefit}
                  hasTotalPermanentDisabilityBenefit={hasTotalPermanentDisabilityBenefit}
                  isMalawiFuneralBenefits={isMalawiFuneralBenefits}
                />
              ),
              ClaimDetails: (
                <ClaimDetails
                  claimDetailsData={
                    this.props.claimInitiationData.initiateClaim
                  }
                  initiateClaimLoader={
                    this.props.claimInitiationData.initiateClaimLoader
                  }
                  initiateClaimError={
                    this.props.claimInitiationData.initiateClaimError
                  }
                />
              ),
            }}
          />
        </Grid>
      </>
    );
  }

}

export default connect((state) => ({
  customerData: state.currentCustomer,
  claimInitiationData: state.claimInitiationData,
  customerStatusV2Data: state.customerStatusV2Data,
  userData: state.userAdmin,
  globalData: state.global,
}))(ClaimInitiation);